import { ActionTree, MutationTree, GetterTree } from 'vuex';

import { DictionariesApi } from '@/api/DictionariesApi';

const state = {
   items: [],
};

const mutations: MutationTree<any> = {
   SET_ITEMS(state, items: any) {
      state.items = items;
   },
};

const getters: GetterTree<any, any> = {};

const actions: ActionTree<any, any> = {
   SET_ITEMS({ commit }) {
      return DictionariesApi.beneficiaries().then(resp => {
         commit('SET_ITEMS', resp);
         return resp.length;
      });
   },
   GET_ACCOUNTS({ commit }, id: number) {
      return DictionariesApi.beneficiary_account(id);
   },
};

export default {
   namespaced: true,
   state,
   getters,
   mutations,
   actions,
};
